import { Heading, Paragraph } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

export const HorizontalAlignment = styled.div`
    display: flex;
    flex-wrap: nowrap;
    gap: ${getPurpurSpacing('400')};
    flex-direction: column;

    ${purpurMedia('md')`
        align-items: center;
        flex-direction: row;
    `}
`;

const sizeBig = '12.5rem';
const sizeSmall = '6.25rem';
export const Pictogram = styled.img`
    margin: auto 0;
    ${purpurMedia('sm')`
        max-height: ${sizeSmall};
        max-width: ${sizeSmall};
    `}
    ${purpurMedia('md')`
        max-height: ${sizeBig};
        max-width: ${sizeBig};
    `}
`;

export const ModalDescription = styled(Paragraph).attrs({ variant: 'paragraph-100' })`
    margin-bottom: ${getPurpurSpacing('400')};
`;

export const GiftGrid = styled.div.attrs({ role: 'list' })`
    display: grid;
    ${purpurMedia('sm')`
        grid-auto-rows: 8rem auto;
        gap: ${getPurpurSpacing('200')};
    `}
    ${purpurMedia('lg')`
        grid-auto-rows: auto;
        grid-template-columns: 12.5rem auto;
        gap: ${getPurpurSpacing('400')};
    `}
`;

export const GiftCellTitle = styled(Heading)`
    margin-bottom: ${getPurpurSpacing('100')};
`;

export const GiftImageCell = styled.img`
    ${purpurMedia('sm')`
        width: auto;
        height: 100%;
    `}
    ${purpurMedia('lg')`
        padding: ${getPurpurSpacing('300')};
        width: 100%;
        height: auto;
    `}
`;
export const GiftDescriptionCell = styled.div.attrs({ role: 'listitem' })`
    ${purpurMedia('sm')`
        padding-bottom: ${getPurpurSpacing('300')};
    `}
    ${purpurMedia('lg')`
        padding-bottom: ${getPurpurSpacing('100')};
    `}
`;

export const GiftDescription = styled(Paragraph).attrs({ variant: 'paragraph-100' })`
    margin: ${getPurpurSpacing('100')} 0;
`;
